import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import CommonSection from "../shared/CommonSection";
import "./../styles/tour-packages.css";
import emailjs from "emailjs-com";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate
import AchievementsSection from "../shared/AchievementsSection";
import { Helmet } from "react-helmet";
import tour1 from "./../assets/images/city-palace.jpg";
import tour2 from "./../assets/images/jaipur-village-safari-THUMB.jpg";
import tour3 from "./../assets/images/night-2.jpg";

import Newsletter from "../shared/Newsletter";
import Subtitle from "../shared/Subtitle";

const TourPackages = () => {
  const location = useLocation();
  const storedCategory = location.state?.selectedCategory || "";
  const [selectedCategory, setSelectedCategory] = useState(storedCategory);
  const [isFormOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    fromDate: "",
    destination: "",
    pickFrom: "Delhi",
    numberOfPeople: 0,
  });

  const serviceID = "service_2459xbb";
  const templateID = "template_58945jj";
  const userID = "mRKco-Lkgq2hUda_Q";

  const tourData = [
    {
      name: "JAIPUR SIGHTSEEING DAY TOUR",
      category: "Jaipur Tour Packages",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour1,
    },
    {
      name: "JAIPUR JEEP SAFARI",
      category: "Jaipur Tour Packages",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour2,
    },
    {
      // name: "NIGHT OPEN AIR CITY TOURS OF JAIPUR",
      name: "OPEN-AIR NIGHT TOUR OF JAIPUR CITY",
      category: "Jaipur Tour Packages",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tour3,
    },
  ];
  const navigate = useNavigate();
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    navigate("/tour-packages", {
      state: { selectedCategory: category },
      replace: true,
    });
  };

  const filteredtours = tourData.filter(
    (tour) => tour.category === selectedCategory || selectedCategory === ""
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory]);

  const indexOfLasttour = currentPage * itemsPerPage;
  const indexOfFirsttour = indexOfLasttour - itemsPerPage;
  const currenttours = filteredtours.slice(indexOfFirsttour, indexOfLasttour);

  const openForm = () => {
    setFormOpen(true);
  };

  const closeForm = () => {
    setFormOpen(false);
    setFormData({
      name: "",
      fromDate: "",
      destination: "",
      pickFrom: "Delhi",
      numberOfPeople: 0,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "fromDate":
        const today = new Date().toISOString().split("T")[0];
        if (value < today) {
          return;
        }
        break;
      case "numberOfPeople":
        if (value < 0) {
          return;
        }
        break;
      // Add cases for other input fields if needed
      default:
        break;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log("Email sent successfully:", response);
        closeForm();
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

    window.scrollTo(0, 0);
  };

  // Function to navigate to the tour details page
  const navigateToTourDetails = (tourCategory, tourName) => {
    const categorySlug = tourCategory.split(" ").join("-").toLowerCase();
    const tourNameSlug = tourName.split(" ").join("-").toLowerCase();
    navigate(`/tour-packages/${categorySlug}/${tourNameSlug}`);
  };

  return (
    <>
      <Helmet>
        <title>Tour Packages - The Rustic Paths</title>
        <meta name="description" content="Explore our diverse tour packages." />
        <meta
          name="keywords"
          content="The Rustic Paths, book a driver in India, tour packages India, Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Char Dham Tour, Short Tour"
        />
        {/* Add other meta tags as needed */}
      </Helmet>
      <CommonSection title={"Tour Packages"} />
      <section className="tour-rental-section py-12">
        <Container>
          <Row>
            <div className="container mx-auto px-4 ">
              <h2 className="text-3xl font-semibold text-gray-800 mb-8 ">
                Book Your Bespoke Tour Package
              </h2>

              <div className="button__group mb-4" style={{ marginTop: "20px" }}>
                <button
                  onClick={() => handleCategoryChange("")}
                  className={`filter-button ${
                    selectedCategory === "" ? "active" : ""
                  }`}
                >
                  All Packages
                </button>
                {/* <button
                  onClick={() => handleCategoryChange("Golden Triangle Tours")}
                  className={`filter-button ${
                    selectedCategory === "Golden Triangle Tours" ? "active" : ""
                  }`}
                >
                  Golden Triangle Tours
                </button>
                <button
                  onClick={() =>
                    handleCategoryChange("Rajasthan Tour Packages")
                  }
                  className={`filter-button ${
                    selectedCategory === "Rajasthan Tour Packages"
                      ? "active"
                      : ""
                  }`}
                >
                  Rajasthan Tour Packages
                </button>
                <button
                  onClick={() =>
                    handleCategoryChange("Char Dham Tour Packages")
                  }
                  className={`filter-button ${
                    selectedCategory === "Char Dham Tour Packages"
                      ? "active"
                      : ""
                  }`}
                >
                  Char Dham Tour Packages
                </button> */}
                <button
                  onClick={() => handleCategoryChange("Jaipur Tour Packages")}
                  className={`filter-button ${
                    selectedCategory === "Jaipur Tour Packages"
                      ? "active"
                      : ""
                  }`}
                >
                  Jaipur Tour Packages
                </button>
                {/* <button
                  onClick={() => handleCategoryChange("South India Tours")}
                  className={`filter-button ${
                    selectedCategory === "South India Tours" ? "active" : ""
                  }`}
                >
                  South India Tours
                </button>
                <button
                  onClick={() => handleCategoryChange("Short Tour Packages")}
                  className={`filter-button ${
                    selectedCategory === "Short Tour Packages" ? "active" : ""
                  }`}
                >
                  Short Tour Packages
                </button>
                <button
                  onClick={() => handleCategoryChange("Uttrakhand Tour Packages")}
                  className={`filter-button ${
                    selectedCategory === "Uttrakhand Tour Packages" ? "active" : ""
                  }`}
                >
                  Uttrakhand Tour Packages
                </button> */}
              </div>

              <Row>
                {currenttours.map((tour, index) => (
                  <Col key={index} sm="12" md="6" lg="4" className="mb-4">
                    <div className="tour__option bg-white p-6 rounded-lg shadow-lg flex relative">
                      <div className="w-1/2">
                        <img
                          src={tour.image}
                          alt={tour.name}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="w-1/2">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center border-b pb-2">
                          {tour.name}
                        </h3>
                        <div className="text-center text-gray-600 mb-4">
                          <strong>Category:</strong> {tour.category}
                        </div>
                        {/* Add any other tour information you want to display */}
                        <div className="text-center ">
                          <button
                            onClick={() => {
                              navigateToTourDetails(tour.category, tour.name); // Navigate to tour details page
                            }}
                            className="btn primary__btn bg-blue-500 text-white px-4 py-3 rounded-full hover.bg-blue-600 mb-4"
                          >
                            Know More
                          </button>
                        </div>
                      </div>
                      <div className="blur-border"></div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className="pagination">
              {filteredtours.length > itemsPerPage &&
                Array(Math.ceil(filteredtours.length / itemsPerPage))
                  .fill()
                  .map((_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={`page-button ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
            </div>
            <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>

        {isFormOpen && (
          <div className="form-popup">
            <form onSubmit={handleSubmit}>
              <label>
                Name:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                From Date:
                <input
                  type="date"
                  name="fromDate"
                  value={formData.fromDate}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split("T")[0]}
                />
              </label>
              <label>
                Destination:
                <input
                  type="text"
                  name="destination"
                  value={formData.destination}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Pick From:
                <input
                  type="text"
                  name="pickFrom"
                  value={formData.pickFrom}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Number of People:
                <input
                  type="number"
                  name="numberOfPeople"
                  value={formData.numberOfPeople}
                  onChange={handleInputChange}
                  min="0"
                />
              </label>
              <button type="submit">Submit</button>
            </form>
          </div>
        )}
      </section>
      {/*--------------------------- Our Achievements Section Start--------------------------*/}
      <section>
        <Container>
          <Row>
            <Col lg="12">
              {/* <div style={{ backgroundColor: "#ffffff" }}>
                <h2 align="center" className="services__subtitle">
                
                </h2>
              </div> */}
              <Subtitle subtitle={"Few of our achievements"}/>
            </Col>
            <Col lg="12">
              <AchievementsSection />
            </Col>
          </Row>
        </Container>
      </section>

      {/*--------------------------- Our Achievements Section End--------------------------*/}
      <Newsletter />
    </>
  );
};

export default TourPackages;
